// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { request } from "@insite/client-framework/Services/ApiService";

const geoLocateUrl = "https://www.googleapis.com/geolocation/v1/geolocate";
const addressValidationUrl = "https://addressvalidation.googleapis.com/v1:validateAddress";

export interface GeoLocateViaIp {
    accuracy: number;
    location: {
        lat: number;
        lng: number;
    };
}

export function getGeoLocateViaIp(parameter: string) {
    return request<GeoLocateViaIp>(`${geoLocateUrl}?key=${parameter}`, "POST", {});
}

export interface GoogleAddress {
    addressLines?: string[];
    locality?: string; // City
    administrativeArea?: string; // State
    postalCode?: string;
    regionCode?: string; // Country
}

export interface GoogleAddressValidationRequest {
    address: GoogleAddress;
}

export interface GoogleAddressValidationResultAddressComponent {
    componentName: { text: string };
    componentType: string;
    confirmationLevel: string;
}

export interface GoogleAddressValidationResultAddress {
    addressComponents: GoogleAddressValidationResultAddressComponent[];
    formattedAddress: string;
    postalAddress: GoogleAddress;
    unconfirmedComponentTypes?: string[];
}

export interface GoogleAddressValidationResultMetadata {
    business: boolean;
    poBox: boolean;
    residential: boolean;
}

export interface GoogleAddressValidationResultVerdict {
    addressComplete: boolean;
    geocodeGranularity: string;
    hasInferredComponents: boolean;
    inputGranularity: string;
    validationGranularity: string;
}

export interface GoogleAddressValidationResult {
    address: GoogleAddressValidationResultAddress;
    metadata: GoogleAddressValidationResultMetadata;
    verdict: GoogleAddressValidationResultVerdict;
}

export interface GoogleAddressValidationResponse {
    responseId: string;
    result: GoogleAddressValidationResult;
}

export function validateAddress(parameter: GoogleAddressValidationRequest, key: string) {
    return request<GoogleAddressValidationResponse>(
        `${addressValidationUrl}?key=${key}`,
        "POST",
        {},
        JSON.stringify(parameter),
    );
}
